import React from 'react';
import { useApp } from '../context/AppContext';
import SongCard from '../components/SongCard';
import { PLAYLISTS, GENRES } from '../mock/mock';
import { Link } from 'react-router-dom';
import { Sparkles, Mic, Wand2, ArrowRight } from 'lucide-react';
import { Button } from '../components/ui/button';

export default function Home() {
  const { t, lang, library, feed } = useApp();
  const trending = feed.slice(0, 8);
  const forYou = feed.slice(4, 12);
  const fresh = [...library, ...feed].slice(0, 6);

  return (
    <div className="px-4 lg:px-8 py-6 fade-up">
      {/* Hero */}
      <section className="relative overflow-hidden rounded-2xl border border-white/10 bg-[#111114] p-6 md:p-10">
        <div className="absolute inset-0 opacity-30 pointer-events-none" style={{
          background: 'radial-gradient(800px 300px at 10% 0%, rgba(255,62,165,.25), transparent), radial-gradient(600px 240px at 90% 100%, rgba(255,210,61,.18), transparent)'
        }} />
        <div className="relative flex flex-col md:flex-row items-start md:items-center gap-6">
          <div className="flex-1">
            <div className="pill mb-3"><Sparkles size={12} className="text-yellow-300" /> AI Studio</div>
            <h1 className="font-display text-3xl md:text-5xl font-extrabold leading-tight">
              {t('home.hero_title')}
            </h1>
            <p className="mt-3 text-zinc-400 max-w-xl">{t('home.hero_sub')}</p>
            <div className="mt-5 flex flex-wrap gap-2">
              <Link to="/create"><Button className="bg-white text-black hover:bg-zinc-200 gap-2"><Wand2 size={16} /> {t('home.start')}</Button></Link>
              <Link to="/explore"><Button variant="outline" className="border-white/15 bg-transparent hover:bg-white/5 gap-2">{t('nav.explore')} <ArrowRight size={16} /></Button></Link>
            </div>
            <div className="mt-5 flex items-center gap-3 text-xs text-zinc-500">
              <Mic size={14} /> {lang==='fr' ? "Paroles IA · Beats illimités · FR/EN" : "AI lyrics · Endless beats · FR/EN"}
            </div>
          </div>
          <div className="relative w-full md:w-80 aspect-square rounded-2xl overflow-hidden border border-white/10">
            <img src={(feed[0] && feed[0].cover) || ''} alt="" className="w-full h-full object-cover spin-slow" />
            <div className="absolute inset-0 flex items-center justify-center">
              <div className="w-10 h-10 rounded-full bg-black/70 backdrop-blur border border-white/20" />
            </div>
          </div>
        </div>
      </section>

      {/* Genre chips */}
      <section className="mt-8">
        <div className="flex items-center justify-between mb-3">
          <h2 className="text-lg font-semibold">{t('home.genreSpotlight')}</h2>
        </div>
        <div className="flex flex-wrap gap-2">
          {GENRES.map(g => (
            <Link key={g} to={`/explore?g=${encodeURIComponent(g)}`} className="pill hover:bg-white/10 transition-colors cursor-pointer">{g}</Link>
          ))}
        </div>
      </section>

      {/* Trending */}
      <section className="mt-10">
        <div className="flex items-center justify-between mb-4">
          <h2 className="text-lg font-semibold">{t('home.trending')}</h2>
          <Link to="/explore" className="text-sm text-zinc-400 hover:text-white">{lang==='fr'?'Voir tout':'See all'}</Link>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 xl:grid-cols-5 gap-4">
          {trending.map(s => <SongCard key={s.id} song={s} list={trending} />)}
        </div>
      </section>

      {/* For you */}
      <section className="mt-12">
        <div className="flex items-center justify-between mb-4">
          <h2 className="text-lg font-semibold">{t('home.forYou')}</h2>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 xl:grid-cols-5 gap-4">
          {forYou.map(s => <SongCard key={s.id} song={s} list={forYou} />)}
        </div>
      </section>

      {/* New releases */}
      <section className="mt-12 mb-32">
        <div className="flex items-center justify-between mb-4">
          <h2 className="text-lg font-semibold">{t('home.newReleases')}</h2>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
          {fresh.map(s => <SongCard key={s.id} song={s} list={fresh} layout="row" />)}
        </div>
      </section>
    </div>
  );
}
